import { render } from "./RoomThisWeekTabCont.vue?vue&type=template&id=5a61c7a9"
import script from "./RoomThisWeekTabCont.vue?vue&type=script&lang=js"
export * from "./RoomThisWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__